{
    "RTE_Label": "Begin te typen...",
    "NAME": "RichTextEditor"
}